export default "__VITE_ASSET__6a1525cc__"